import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=628bef02&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bef02",
  null
  
)

export default component.exports